import React from 'react'
import styled from 'styled-components'
import { useObserver } from 'mobx-react'
import { Alert } from 'react-bootstrap'
import useStores from '../../../stores/useStore'
import CopySubheader from '../../../components/Configuration/Articles/CopyArticle/CopySubheader'
import Sidebar from '../../../components/Configuration/Articles/CopyArticle/Sidebar'
import CopyContentArea from '../../../components/Configuration/Articles/CopyArticle/CopyContentArea'
import ArticleDataProvider from '../../../stores/Configuration/ArticleDataProvider'
import { StyledJobfunctionContainer } from '../../../components/Employees/Form/formHelper'
import { useTranslation } from 'react-i18next'
import { ContentArea } from '../../../components/Page/logix2020/ContentArea'
import { TestSidebarRight } from '../../../components/Page/logix2020/TestSidebarRight'
import BigFooter from '../../../components/Footer/BigFooter'
import { FlexWrapper } from '../../../components/Page/logix2020/FlexWrapper'

const StyledContentArea = styled(ContentArea)`
   padding: 20px 40px 20px 36px;
   @media (max-width: 1080px) {
    padding: 20px;
    min-height: calc(100vh - 488px);//header+navbar+sidebar=488px
   }
   .added-row {
    label {
      display: block;
    }
  }
`

const CopyArticlePage = () => {
  const { uiStore } = useStores()
  const { t } = useTranslation()

  return useObserver(() => (
    <ArticleDataProvider>
      <StyledJobfunctionContainer>
        {!(uiStore.allowImportArticles) ? (
          <>
            <StyledContentArea>
              <Alert variant="danger">{t('articleAdminOverlayProgress:alert')}</Alert>
            </StyledContentArea>
          </>
        ) : (
          <>
            <CopySubheader />
            <FlexWrapper>
              <StyledContentArea>
                <CopyContentArea />
              </StyledContentArea>
              <TestSidebarRight>
                <Sidebar />
              </TestSidebarRight>
            </FlexWrapper>
            <BigFooter />
          </>
        )}
      </StyledJobfunctionContainer>
    </ArticleDataProvider>

  ))
}

export default CopyArticlePage


